export default "__VITE_ASSET__PRcKkFD7__"